<template>
    <div class="emergency-contact-form" @submit.prevent="submit">
        <span class="text-danger">Note: "Person that does not share the same address with applicant"</span>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form role="form" class="mt-4">
                <b-row>
                    <b-col md="8" cols="12">
                        <b-form-group label="Full Name">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ name: true }"
                                :vid="'fullName'"
                            >
                                <b-form-input
                                v-model="form.name"
                                type="text"
                                placeholder="Enter full name"
                                required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Relationship">
                            <el-select v-model="form.relationship" placeholder="Select">
                                <el-option
                                v-for="item in relationships"
                                :key="item"
                                :label="item"
                                :value="item">
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Emergency Contact">
                            <div class="d-flex justify-content-between">
                                <b-form-input class="col-md-3 mr-1" v-model="form.country_code"></b-form-input>
                                <b-form-input
                                    class="col-md-9"
                                    v-model="form.contact_no"
                                    type="text"
                                    maxlength="17"
                                    @keydown="preventNonNumericInput"
                                    placeholder="Enter Emergency Contact"
                                    required
                                ></b-form-input>
                            </div>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Emergency Address">
                            <b-form-input
                            v-model="form.address"
                            type="text"
                            placeholder="Enter Emergency Address"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Emergency Remarks">
                            <b-form-textarea
                            v-model="form.remarks"
                            placeholder="Enter emergency remarks..."
                            rows="2"
                            max-rows="6"
                            ></b-form-textarea>
                        </b-form-group>
                    </b-col>
                    
                    <b-col cols="8">
                        <b-button block variant="primary" class="w-50" type="submit" :disabled="invalid">Save</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </div>
</template>

<script>
import { Select, Option } from 'element-ui'
import {
    notifyFunctionMixin,
    helperFunctionMixin,
    axios,
    services,
    getHeader
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'


    export default {
        name: 'emergency-info-form',
        props: ['customer', 'tables'],
        mixins:[
            notifyFunctionMixin,
            helperFunctionMixin
        ],
        components: {
            ValidationObserver,
            ValidationProvider,
            [Select.name]: Select,
            [Option.name]: Option,
        },
        data() {
            const {name, relationship, contact_no, address, remarks} = this.customer.emergency_contact || {}
            return {
                form: {
                    customer_id: this.customer.customer_id,
                    name: name ?? null,
                    relationship: relationship ?? null,
                    country_code: this.customer.country_code ?? '+60',
                    contact_no: contact_no ?? null,
                    address: address ?? null,
                    remarks: remarks ?? null,
                },
                relationships: [
                    'Spouse', 
                    'Cousin', 
                    'Siblings', 
                    'Relative', 
                    'Parent', 
                    'Friend', 
                    'Others'
                ],
            }
        },
        methods:{
            ...mapActions(useCustomerStore,['getCustomer']),
            submit(){
                this.customer.emergency_contact ? this.update(this.customer.emergency_contact.customer_emergency_id) : this.create()
            },
            update(id){
                axios.put(services.customer + 'customer/' + this.$route.params.customer_id + '/emergencies/' + id, this.form, {headers: getHeader()})
                .then(res  => {
                        this.notifySuccess('<b>Emergency Contact Information: '+this.customer.name+'</b> - Successfully Updated.')
                        this.getCustomer(this.customer.customer_id)
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },
            create(){
                let formData = this.generateFormData(this.form)
                axios.post(services.customer + 'customer/' + this.$route.params.customer_id + '/emergencies', formData, {headers: getHeader()})
                .then(res  => {
                    this.notifySuccess('<b>Emergency Contact Information: '+this.customer.name+'</b> - Successfully Created.')
                        this.getCustomer(this.customer.customer_id)
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },
            preventNonNumericInput(event) {
                const keyCode = event.keyCode || event.which;
                const keyValue = String.fromCharCode(keyCode);
                const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
                const allowedKeys = [8, 37, 38, 39, 40, 46];
                if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                    event.preventDefault();
                }
            },
        }
    }
</script>